import { ReactNode } from "react";
import { App, ConfigProvider } from "antd";
import ErrorNotifierBridge from "@/query/ErrorNotifierBridge";

const ThemeProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ConfigProvider
      wave={{ disabled: true }}
      theme={{
        cssVar: true,
        token: {
          fontFamily: "Satoshi-Regular",
          borderRadius: 12,
          colorText: "#fff",
          colorTextPlaceholder: "#898989",
          colorPrimary: "#ff5e1f",
          colorPrimaryHover: "#e84200",
          colorPrimaryActive: "#e84200",
          fontSizeIcon: 16,
          colorError: "#EE4444"
        },
        components: {
          Button: {
            fontFamily: "Raleway-SemiBold",
            fontSize: 20,
            controlHeight: 62,
            borderRadius: 100,
            paddingInline: 40
          },
          Input: {
            fontFamily: "Raleway-Medium",
            colorBgContainer: "rgba(255, 255, 255, 0.1)",
            activeBg: "rgba(255, 255, 255, 0.1)",
            hoverBg: "rgba(255, 255, 255, 0.1)",
            addonBg: "rgba(255, 255, 255, 0.1)",
            activeShadow: "none",
            controlHeight: 48,
            fontSize: 14,
            paddingBlock: 14,
            paddingInline: 12,
            borderRadius: 12,
            colorBorder: "rgba(255, 255, 255, 0.3)"
          },
          InputNumber: {
            activeBorderColor: "#070A19",
            hoverBorderColor: "#070A19",
            activeShadow: "none"
          },
          Select: {
            selectorBg: "rgba(255, 255, 255, 0.1)",
            borderRadius: 12,
            controlHeight: 48,
            colorBorder: "rgba(255, 255, 255, 0.3)",
            activeOutlineColor: "none",
            boxShadow: "none",
            controlOutline: "none",
            optionSelectedBg: "#000",
            optionSelectedColor: "#ff5e1f",
            colorTextDisabled: "#fff"
          },
          DatePicker: {
            activeShadow: "none",
            colorPrimary: "#070A19",
            controlHeight: 48,
            cellHeight: 32,
            fontSize: 14,
            colorBgContainer: "rgba(255, 255, 255, 0.1)",
            colorBorder: "rgba(255, 255, 255, 0.3)",
            cellActiveWithRangeBg: "rgba(255, 255, 255, 0.1)"
          },
          Table: {
            fontSizeIcon: 15,
            colorBgContainer: "rgba(255, 255, 255, 0.10)"
            // headerSortActiveBg: "#fafafa",
            // headerSortHoverBg: "#fafafa",
            // bodySortBg: "#ffffff"
          },
          Pagination: {
            borderRadius: 8
          },
          Modal: {
            contentBg: "#1F1F1F",
            headerBg: "#1F1F1F",
            footerBg: "#1F1F1F",
            borderRadius: 16,
            titleColor: "#FFFFFF",
            titleFontSize: 30
          },
          Message: {
            contentBg: "#1F1F1F"
          },
          Form: {
            verticalLabelPadding: "0 0 10px 0",
            itemMarginBottom: 16
          },
          Cascader: {
            optionSelectedBg: "#FF5E1F"
          }
        }
      }}
    >
      <App message={{ maxCount: 1 }} notification={{ maxCount: 1, duration: 3 }}>
        <ErrorNotifierBridge />
        {children}
      </App>
    </ConfigProvider>
  );
};

export default ThemeProvider;
